<template><div><h1 id="newsletter-spontanes-mailing-und-transactional-emails" tabindex="-1"><a class="header-anchor" href="#newsletter-spontanes-mailing-und-transactional-emails"><span>Newsletter, spontanes Mailing und Transactional Emails</span></a></h1>
<h2 id="was-ist-der-unterschied" tabindex="-1"><a class="header-anchor" href="#was-ist-der-unterschied"><span>Was ist der Unterschied</span></a></h2>
<p>Im Fundraising gibt es folgende Unterscheidungen:</p>
<dl>
<dt>Newsletter:</dt>
<dd>Newsletter sind E-Mails, die an eine mehr oder weniger konstante Audienz in regelmässigen Zeitabständen verschickt werden. Klassische Beispiele sind allgemeine Updates, Geschichten oder Informationen über die Organisation.<br/>Beispiel: Ein monatlicher Newsletter mit Neuigkeiten über Projekte und Erfolge.</dd>
<dt>Spontanes Mailing:</dt>
<dd>Einmalige E-Mail-Kampagnen, oft aus aktuellem Anlass.<br/>Beispiel: Eine Spendenaufforderung nach einer Naturkatastrophe.</dd>
<dt>Transactional Emails:</dt>
<dd>Automatisierte E-Mails, die durch eine Aktion des Empfängers ausgelöst werden.<br/>Beispiel: Eine E-Mail zur Bestätigung einer Spende oder einer Anmeldung.</dd>
</dl>
<p>Diese unterscheiden sich in Frequenz und Zweck, um verschiedene Ziele im Fundraising zu unterstützen.</p>
<h2 id="warum-ist-die-unterscheidung-in-funtrade-wichtig" tabindex="-1"><a class="header-anchor" href="#warum-ist-die-unterscheidung-in-funtrade-wichtig"><span>Warum ist die Unterscheidung in funtrade wichtig?</span></a></h2>
<p>Die Unterscheidung machen wir vor allem aus zwei Gründen:</p>
<ol>
<li>
<p>Durch die Unterscheidung können wir die relevanten Informationen (Ereignisse, Aktionen etc.) in funtrade dort darstellen, wo ein Fundraiser sie sucht.</p>
</li>
<li>
<p>Die verschiedenen Mailing-Anbieter, wie bspw. Brevo, begrenzen unter Umständen die Anzahl an &quot;Lists&quot;, je nach Preismodell. Durch die Unterscheidung können wir für alle spontanen Mailings eine einzige &quot;List&quot; verwenden und so dein Budget schonen.</p>
</li>
</ol>
</div></template>


